<template>
  <div class="tw-flex tw-items-center tw-gap-4">
    <div v-if="shouldRenderSearch" class="tw-min-w-[280px]">
      <overview-navigation-search
        data-testid="review-outer-search"
        @searched-for="handleSearch"
      />
    </div>
    <workflow-review-filter
      v-if="allowReviews"
      :ledger-id="props.ledgerId"
      :workflow-id="props.workflowId"
    />
    <progress-indicator
      v-if="itemLength > 0"
      :current-index="effectiveIndex"
      :show-empty="true"
      :total="effectiveLength"
      class="review-scroll-progress"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import OverviewNavigationSearch from '@app/application/workflow-overview-navigation/components/overview-navigation-search.vue'
import ProgressIndicator from './progress-indicator.vue'
import WorkflowReviewFilter from './workflow-review-filter.vue'

import { useDrawer } from '@app/shared/pinia/drawer'
import { useWorkflowOverview } from '@app/application/workflow-overview-navigation/store/overview'
import { useWorkflowOverviewSearch } from '@app/application/workflow-overview-navigation/store/search'
import { useWorfklowReviewItems } from '../store/pinia/workflow-review-items'

defineOptions({
  name: 'WorkflowReviewSubnavSecondaryLeft',
})

interface Props {
  allowReviews?: boolean
  ledgerId: number
  showSearch?: boolean
  workflowId: number
}

const props = defineProps<Props>()

const drawerStore = useDrawer()
const itemsStore = useWorfklowReviewItems()
const overviewStore = useWorkflowOverview()
const overviewSearchStore = useWorkflowOverviewSearch()

const { isLeftDrawerOpen } = storeToRefs(drawerStore)
const { currentIndex, itemLength } = storeToRefs(itemsStore)
const { filteredReviewIndeces, hasAnyFilterApplied } =
  storeToRefs(overviewStore)

const effectiveIndex = computed(() => {
  if (hasAnyFilterApplied.value) {
    const remappedIndex = filteredReviewIndeces.value[currentIndex.value]
    return !remappedIndex && remappedIndex !== 0 ? -1 : remappedIndex
  }

  return currentIndex.value
})

const effectiveLength = computed(() => {
  if (hasAnyFilterApplied.value) {
    return Object.keys(filteredReviewIndeces.value).length || 0
  }

  return itemLength.value
})

const shouldRenderSearch = computed(() => {
  return props.showSearch && !isLeftDrawerOpen.value
})

function handleSearch(value: string | null) {
  if (value) {
    drawerStore.openLeftDrawer()
    overviewSearchStore.focusSearch()
  }
}
</script>
